export const GET_TEAMS = "GET_TEAMS";
export const GET_TEAMS_SUCCESS = "GET_TEAMS_SUCCESS";
export const GET_TEAMS_FAILURE = "GET_TEAMS_FAILURE";
export const ASSIGN_TEAM = "ASSIGN_TEAM";
export const ASSIGN_TEAM_SUCCESS = "ASSIGN_TEAM_SUCCESS";
export const ASSIGN_TEAM_FAILURE = "ASSIGN_TEAM_FAILURE";
export const UNASSIGN_TEAM = "UNASSIGN_TEAM";
export const UNASSIGN_TEAM_SUCCESS = "UNASSIGN_TEAM_SUCCESS";
export const UNASSIGN_TEAM_FAILURE = "UNASSIGN_TEAM_FAILURE";
export const RESET_TEAM_SUCCESS = "RESET_TEAM_SUCCESS";
export const API_FAILED = "TEAMS_API_FAILED";
